<template>

<core-panel>

	<template v-slot:head>

		<h1>Exploration</h1>

		<p>All <b>{{ items.length }}</b> attributes from this game and how much you've explored.</p>

	</template>

	<template v-slot:body>

		<div class="exploration-row" v-for="(item, index) in items" :key="index" v-on:click="onSelect(item)" v-tooltip="'View ' + item.name + ' games'">

			<div class="exploration-row-head">

				<div class="exploration-row-name">{{ item.name }}<span class="exploration-row-type">{{ item.type }}</span></div>

				<div class="exploration-row-count">{{ item.tried }}<span class="exploration-row-total"> / {{ item.total }}</span></div>

			</div>

			<div class="exploration-row-bar">

				<div class="exploration-row-bar-fill" :style="{ width: item.percent + '%' }" />

			</div>

		</div>

	</template>

</core-panel>

</template>

<script>

import Panel from './../../common/Panel'

export default {

	mixins: [Panel],

	data: function() {

		return {
			detail: 'affinity',
			items: []
		}

	},

	methods: {

		response: function(json) {

			this.items = json.affinity.exploration

		},

		onSelect: function(item) {

			this.$pubsub.$emit('panel.open', {
				type: 'insightsGameAffinityAttribute',
				id: this.data ? this.data.id : 0,
				attrType: item.type,
				attrId: item.id,
				child: true
			})

		}

	}

}

</script>

<style scoped>

.exploration-row {
	padding: 10px 15px;
	cursor: pointer;
}

.exploration-row:nth-child(odd) {
	background-color: rgba(12, 137, 178, 0.05);
}

.exploration-row:hover {
	background-color: rgba(72, 129, 187, 0.1);
}

.exploration-row-head {
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 6px;
}

.exploration-row-name {
	font-size: 14px;
	font-weight: 600;
	color: #333;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	min-width: 0;
}

.exploration-row-type {
	font-size: 10px;
	font-weight: 600;
	text-transform: uppercase;
	letter-spacing: 0.3px;
	color: #999;
	margin-left: 6px;
}

.exploration-row-count {
	font-size: 18px;
	font-weight: 700;
	color: #4881bb;
	flex-shrink: 0;
	margin-left: 10px;
}

.exploration-row-total {
	font-size: 12px;
	font-weight: 400;
	color: #999;
}

.exploration-row-bar {
	height: 4px;
	background-color: rgba(0, 0, 0, 0.04);
	border-radius: 2px;
}

.exploration-row-bar-fill {
	height: 100%;
	background-color: #4881bb;
	border-radius: 2px;
}

</style>
